import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';

import { AuthorizationService } from '../../../shared/index';

import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'fmiproduct-index',
    templateUrl: './fmiproduct-index.html',
    standalone: false
})

export class FMIProductIndexComponent implements OnInit, OnDestroy {
    @ViewChild('verifyDocumentModal') verifyDocumentModal: ModalDirective;

    public verificationRunning = false;


    constructor(
        private _authorizationService: AuthorizationService,
        //private _catalogService: CatalogService
    )
    {


    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
        //for (let subscription of this.subscriptions) {
        //    subscription.unsubscribe();
        //}
    }

    public verifyDocuments(): void {
        this.verifyDocumentModal.show();
    }

    public startVerification(): void {
        this.verificationRunning = true;

    }

    public cancelVerification(): void {
        this.verificationRunning = false;
        this.verifyDocumentModal.hide();

    }
}
